import React from 'react';
import InfoContainerMD from '../../core/infoContainerMD';
import { schoolInfoConfig } from '../configs/schoolsInfoConfig';
import IdentityApproverPanel from './identityApproverPanel';


const SchoolInformationTab = ({data, handleOpen, updating, setUpdating }) => {
    return (
        <>
        <InfoContainerMD
            config={schoolInfoConfig}
            infoData={data}
            incidentData={true}
            handleOpen={handleOpen}
            updating={updating}
            setUpdating={setUpdating}
            type={"schools"}
        />
        <IdentityApproverPanel data={data} />
        </>
    );
};

export default SchoolInformationTab;